/**
 * Test an object to satisfy the criteria when using 'keyof' - this function will
 * ensure that the key exist in the object and allow the keyof usage
 * @param key is a string that act as a key
 * @param typedObject is an object of any type that need to be checked
 * @returns boolean whether the key is present in object
 */
const isKeyInObject = <TypeToCheck extends object>(
  key: PropertyKey,
  typedObject: TypeToCheck,
): key is keyof TypeToCheck => key in typedObject;

export default isKeyInObject;
